export const DEFAULT_COUNTRY_PHONE = {
  id: '91a3acd7-d985-494f-b589-be4d1a1208ed',
  countryName: 'Thailand',
  countryCode: 'TH',
  phoneCode: '+66',
  region: null,
  flag: 'U+1F1F9 U+1F1ED',
  active: true,
  createdAt: '2024-05-17T04:30:01.155Z',
  updatedAt: '2024-05-21T02:44:02.660Z',
}

// GET https://api.bdms.tech/notification-center/country - 20241225
export const DEFAULT_COUNTRY_LIST = [
  {
    id: 'd53a0649-a31b-42bb-87a5-288152441a1d',
    countryName: 'Afghanistan',
    countryCode: 'AF',
    phoneCode: '+93',
    region: null,
    flag: 'U+1F1E6 U+1F1EB',
    active: true,
    createdAt: '2024-07-18T17:07:32.668Z',
    updatedAt: '2024-12-19T16:16:05.719Z',
  },
  {
    id: '1a6a387b-2142-4810-8931-3fde5ba82ba2',
    countryName: 'Aland Islands',
    countryCode: 'AX',
    phoneCode: '+358',
    region: null,
    flag: 'U+1F1E6 U+1F1FD',
    active: true,
    createdAt: '2024-07-18T17:07:32.749Z',
    updatedAt: '2024-12-19T16:16:05.806Z',
  },
  {
    id: 'd2735e74-f1b9-41d8-9581-4e517d8706cb',
    countryName: 'Albania',
    countryCode: 'AL',
    phoneCode: '+355',
    region: null,
    flag: 'U+1F1E6 U+1F1F1',
    active: true,
    createdAt: '2024-07-18T17:07:32.743Z',
    updatedAt: '2024-12-19T16:16:05.805Z',
  },
  {
    id: 'c4bf1cc4-3ea9-44b4-9dcd-4316442f444b',
    countryName: 'Algeria',
    countryCode: 'DZ',
    phoneCode: '+213',
    region: null,
    flag: 'U+1F1E9 U+1F1FF',
    active: true,
    createdAt: '2024-07-18T17:07:32.763Z',
    updatedAt: '2024-12-19T16:16:05.815Z',
  },
  {
    id: '1e501920-3909-442f-8371-9ced1ecb06c6',
    countryName: 'American Samoa',
    countryCode: 'AS',
    phoneCode: '+1684',
    region: null,
    flag: 'U+1F1E6 U+1F1F8',
    active: true,
    createdAt: '2024-07-18T17:07:32.745Z',
    updatedAt: '2024-12-19T16:16:05.805Z',
  },
  {
    id: 'be3e8a19-9df3-44e2-b0fb-ed6ed638222c',
    countryName: 'Andorra',
    countryCode: 'AD',
    phoneCode: '+376',
    region: null,
    flag: 'U+1F1E6 U+1F1E9',
    active: true,
    createdAt: '2024-07-18T17:07:32.613Z',
    updatedAt: '2024-12-19T16:16:05.697Z',
  },
  {
    id: 'dfbc46b5-9c1f-40a0-afd4-d16bb1ba95fd',
    countryName: 'Angola',
    countryCode: 'AO',
    phoneCode: '+244',
    region: null,
    flag: 'U+1F1E6 U+1F1F4',
    active: true,
    createdAt: '2024-07-18T17:07:32.743Z',
    updatedAt: '2024-12-19T16:16:05.805Z',
  },
  {
    id: '20184976-2d8f-4292-bdc6-48587263fb57',
    countryName: 'Anguilla',
    countryCode: 'AI',
    phoneCode: '+1264',
    region: null,
    flag: 'U+1F1E6 U+1F1EE',
    active: true,
    createdAt: '2024-07-18T17:07:32.743Z',
    updatedAt: '2024-12-19T16:16:05.804Z',
  },
  {
    id: '4e40fa10-89ae-4758-b096-f49e305ce877',
    countryName: 'Antarctica',
    countryCode: 'AQ',
    phoneCode: '+672',
    region: null,
    flag: 'U+1F1E6 U+1F1F6',
    active: true,
    createdAt: '2024-07-18T17:07:32.744Z',
    updatedAt: '2024-12-19T16:16:05.805Z',
  },
  {
    id: '45b918bb-dc73-4e40-9b07-c3bf455f6237',
    countryName: 'Antigua & Barbuda',
    countryCode: 'AG',
    phoneCode: '+1268',
    region: null,
    flag: 'U+1F1E6 U+1F1EC',
    active: true,
    createdAt: '2024-07-18T17:07:32.742Z',
    updatedAt: '2024-12-19T16:16:05.804Z',
  },
  {
    id: '9ca29d64-3945-4aac-b219-fb623c9f9bcf',
    countryName: 'Argentina',
    countryCode: 'AR',
    phoneCode: '+54',
    region: null,
    flag: 'U+1F1E6 U+1F1F7',
    active: true,
    createdAt: '2024-07-18T17:07:32.745Z',
    updatedAt: '2024-12-19T16:16:05.805Z',
  },
  {
    id: '945081e1-abb7-42ec-a6b2-8f94e0b5bfcc',
    countryName: 'Armenia',
    countryCode: 'AM',
    phoneCode: '+374',
    region: null,
    flag: 'U+1F1E6 U+1F1F2',
    active: true,
    createdAt: '2024-07-18T17:07:32.743Z',
    updatedAt: '2024-12-19T16:16:05.805Z',
  },
  {
    id: 'd6f1f44f-cf38-4e31-b9cb-34380e4e9846',
    countryName: 'Aruba',
    countryCode: 'AW',
    phoneCode: '+297',
    region: null,
    flag: 'U+1F1E6 U+1F1FC',
    active: true,
    createdAt: '2024-07-18T17:07:32.748Z',
    updatedAt: '2024-12-19T16:16:05.806Z',
  },
  {
    id: '62af8bab-61f4-41cb-b86b-d8266bcdaec3',
    countryName: 'Australia',
    countryCode: 'AU',
    phoneCode: '+61',
    region: null,
    flag: 'U+1F1E6 U+1F1FA',
    active: true,
    createdAt: '2024-07-18T17:07:32.745Z',
    updatedAt: '2024-12-19T16:16:05.806Z',
  },
  {
    id: '3ff450cd-561c-4e65-98c6-6f9b79c28677',
    countryName: 'Austria',
    countryCode: 'AT',
    phoneCode: '+43',
    region: null,
    flag: 'U+1F1E6 U+1F1F9',
    active: true,
    createdAt: '2024-07-18T17:07:32.745Z',
    updatedAt: '2024-12-19T16:16:05.806Z',
  },
  {
    id: 'd05ad788-a74a-45c3-96a3-deb52ee590e5',
    countryName: 'Azerbaijan',
    countryCode: 'AZ',
    phoneCode: '+994',
    region: null,
    flag: 'U+1F1E6 U+1F1FF',
    active: true,
    createdAt: '2024-07-18T17:07:32.749Z',
    updatedAt: '2024-12-19T16:16:05.806Z',
  },
  {
    id: '02022e73-5c8e-4247-912f-706a33959c3a',
    countryName: 'Bahamas',
    countryCode: 'BS',
    phoneCode: '+1242',
    region: null,
    flag: 'U+1F1E7 U+1F1F8',
    active: true,
    createdAt: '2024-07-18T17:07:32.752Z',
    updatedAt: '2024-12-19T16:16:05.809Z',
  },
  {
    id: '649a764a-5f73-41d0-ae2e-3face1f14808',
    countryName: 'Bahrain',
    countryCode: 'BH',
    phoneCode: '+973',
    region: null,
    flag: 'U+1F1E7 U+1F1ED',
    active: true,
    createdAt: '2024-07-18T17:07:32.751Z',
    updatedAt: '2024-12-19T16:16:05.808Z',
  },
  {
    id: '314b32e7-adf5-4fec-b9da-cc84170d1d6e',
    countryName: 'Bangladesh',
    countryCode: 'BD',
    phoneCode: '+880',
    region: null,
    flag: 'U+1F1E7 U+1F1E9',
    active: true,
    createdAt: '2024-07-18T17:07:32.749Z',
    updatedAt: '2024-12-19T16:16:05.807Z',
  },
  {
    id: '4dae61e9-7546-4014-adcc-63e077fd7e81',
    countryName: 'Barbados',
    countryCode: 'BB',
    phoneCode: '+1246',
    region: null,
    flag: 'U+1F1E7 U+1F1E7',
    active: true,
    createdAt: '2024-07-18T17:07:32.749Z',
    updatedAt: '2024-12-19T16:16:05.807Z',
  },
  {
    id: 'e6497ae1-b83c-4c99-8b60-923b93c87388',
    countryName: 'Belarus',
    countryCode: 'BY',
    phoneCode: '+375',
    region: null,
    flag: 'U+1F1E7 U+1F1FE',
    active: true,
    createdAt: '2024-07-18T17:07:32.753Z',
    updatedAt: '2024-12-19T16:16:05.810Z',
  },
  {
    id: 'd7f66229-7cec-4d6d-8076-da71bfc2c669',
    countryName: 'Belgium',
    countryCode: 'BE',
    phoneCode: '+32',
    region: null,
    flag: 'U+1F1E7 U+1F1EA',
    active: true,
    createdAt: '2024-07-18T17:07:32.750Z',
    updatedAt: '2024-12-19T16:16:05.807Z',
  },
  {
    id: '6bcea47d-7dd6-4a3a-acca-66a1c333b198',
    countryName: 'Belize',
    countryCode: 'BZ',
    phoneCode: '+501',
    region: null,
    flag: 'U+1F1E7 U+1F1FF',
    active: true,
    createdAt: '2024-07-18T17:07:32.756Z',
    updatedAt: '2024-12-19T16:16:05.810Z',
  },
  {
    id: 'd1d850a3-7a2c-4064-8b81-9345213bbe0a',
    countryName: 'Benin',
    countryCode: 'BJ',
    phoneCode: '+229',
    region: null,
    flag: 'U+1F1E7 U+1F1EF',
    active: true,
    createdAt: '2024-07-18T17:07:32.751Z',
    updatedAt: '2024-12-19T16:16:05.808Z',
  },
  {
    id: 'fd8d047e-b7ef-4ed9-b8f8-f68cd6647396',
    countryName: 'Bermuda',
    countryCode: 'BM',
    phoneCode: '+1441',
    region: null,
    flag: 'U+1F1E7 U+1F1F2',
    active: true,
    createdAt: '2024-07-18T17:07:32.751Z',
    updatedAt: '2024-12-19T16:16:05.809Z',
  },
  {
    id: '7fb2fe63-b4d9-4685-866e-45332c47edf0',
    countryName: 'Bhutan',
    countryCode: 'BT',
    phoneCode: '+975',
    region: null,
    flag: 'U+1F1E7 U+1F1F9',
    active: true,
    createdAt: '2024-07-18T17:07:32.752Z',
    updatedAt: '2024-12-19T16:16:05.809Z',
  },
  {
    id: 'f7e2f37d-99fa-4e74-b0e1-b3e53e935621',
    countryName: 'Bolivia',
    countryCode: 'BO',
    phoneCode: '+591',
    region: null,
    flag: 'U+1F1E7 U+1F1F4',
    active: true,
    createdAt: '2024-07-18T17:07:32.752Z',
    updatedAt: '2024-12-19T16:16:05.809Z',
  },
  {
    id: '0f8c6ba8-655a-4196-86f7-e208003a54a1',
    countryName: 'Bosnia & Herzegovina',
    countryCode: 'BA',
    phoneCode: '+387',
    region: null,
    flag: 'U+1F1E7 U+1F1E6',
    active: true,
    createdAt: '2024-07-18T17:07:32.749Z',
    updatedAt: '2024-12-19T16:16:05.807Z',
  },
  {
    id: '646f3490-4f7f-4267-85aa-7ebd4cfbd2fe',
    countryName: 'Botswana',
    countryCode: 'BW',
    phoneCode: '+267',
    region: null,
    flag: 'U+1F1E7 U+1F1FC',
    active: true,
    createdAt: '2024-07-18T17:07:32.752Z',
    updatedAt: '2024-12-19T16:16:05.810Z',
  },
  {
    id: '2f512b5f-c111-4e32-8855-b8329eadebe7',
    countryName: 'Brazil',
    countryCode: 'BR',
    phoneCode: '+55',
    region: null,
    flag: 'U+1F1E7 U+1F1F7',
    active: true,
    createdAt: '2024-07-18T17:07:32.752Z',
    updatedAt: '2024-12-19T16:16:05.809Z',
  },
  {
    id: 'ee9dd3d9-15d6-4c60-ac0e-bd189188cf36',
    countryName: 'British Indian Ocean Territory',
    countryCode: 'IO',
    phoneCode: '+246',
    region: null,
    flag: 'U+1F1EE U+1F1F4',
    active: true,
    createdAt: '2024-07-18T17:07:32.804Z',
    updatedAt: '2024-12-19T16:16:05.827Z',
  },
  {
    id: 'ab738351-bcef-4a6a-bd17-abdce6a15b80',
    countryName: 'British Virgin Islands',
    countryCode: 'VG',
    phoneCode: '+1284',
    region: null,
    flag: 'U+1F1FB U+1F1EC',
    active: true,
    createdAt: '2024-07-18T17:07:32.858Z',
    updatedAt: '2024-12-19T16:16:05.914Z',
  },
  {
    id: '9d661225-0cd6-482f-a0b0-94d430142d43',
    countryName: 'Brunei',
    countryCode: 'BN',
    phoneCode: '+673',
    region: null,
    flag: 'U+1F1E7 U+1F1F3',
    active: true,
    createdAt: '2024-07-18T17:07:32.751Z',
    updatedAt: '2024-12-19T16:16:05.809Z',
  },
  {
    id: 'c65951f8-6b22-4282-8f34-b920560bab82',
    countryName: 'Bulgaria',
    countryCode: 'BG',
    phoneCode: '+359',
    region: null,
    flag: 'U+1F1E7 U+1F1EC',
    active: true,
    createdAt: '2024-07-18T17:07:32.750Z',
    updatedAt: '2024-12-19T16:16:05.808Z',
  },
  {
    id: '9655379a-1ad2-4c02-b583-99a541b187bb',
    countryName: 'Burkina Faso',
    countryCode: 'BF',
    phoneCode: '+226',
    region: null,
    flag: 'U+1F1E7 U+1F1EB',
    active: true,
    createdAt: '2024-07-18T17:07:32.750Z',
    updatedAt: '2024-12-19T16:16:05.808Z',
  },
  {
    id: '16942bae-6971-477c-8992-a1c95ff6919c',
    countryName: 'Burundi',
    countryCode: 'BI',
    phoneCode: '+257',
    region: null,
    flag: 'U+1F1E7 U+1F1EE',
    active: true,
    createdAt: '2024-07-18T17:07:32.751Z',
    updatedAt: '2024-12-19T16:16:05.808Z',
  },
  {
    id: '259c902a-a5eb-4f4d-b229-062e4c9ebf53',
    countryName: 'Cambodia',
    countryCode: 'KH',
    phoneCode: '+855',
    region: null,
    flag: 'U+1F1F0 U+1F1ED',
    active: true,
    createdAt: '2024-07-18T17:07:32.805Z',
    updatedAt: '2024-12-19T16:16:05.890Z',
  },
  {
    id: '3f705591-4904-4447-8e21-fda54a981c35',
    countryName: 'Cameroon',
    countryCode: 'CM',
    phoneCode: '+237',
    region: null,
    flag: 'U+1F1E8 U+1F1F2',
    active: true,
    createdAt: '2024-07-18T17:07:32.758Z',
    updatedAt: '2024-12-19T16:16:05.812Z',
  },
  {
    id: 'ceac4108-da06-433c-b89c-20c2fd7d9db8',
    countryName: 'Canada',
    countryCode: 'CA',
    phoneCode: '+1',
    region: null,
    flag: 'U+1F1E8 U+1F1E6',
    active: true,
    createdAt: '2024-07-18T17:07:32.756Z',
    updatedAt: '2024-12-19T16:16:05.810Z',
  },
  {
    id: '1107738a-0913-48b4-9054-95d2d7154ca4',
    countryName: 'Cape Verde',
    countryCode: 'CV',
    phoneCode: '+238',
    region: null,
    flag: 'U+1F1E8 U+1F1FB',
    active: true,
    createdAt: '2024-07-18T17:07:32.759Z',
    updatedAt: '2024-12-19T16:16:05.813Z',
  },
  {
    id: 'a53d60c9-38ec-4a98-bf1c-e69926aa330c',
    countryName: 'Cayman Islands',
    countryCode: 'KY',
    phoneCode: '+ 345',
    region: null,
    flag: 'U+1F1F0 U+1F1FE',
    active: true,
    createdAt: '2024-07-18T17:07:32.806Z',
    updatedAt: '2024-12-19T16:16:05.892Z',
  },
  {
    id: '3cc7e335-7dc8-4b6d-a7c0-5c118ba9b4cf',
    countryName: 'Central African Republic',
    countryCode: 'CF',
    phoneCode: '+236',
    region: null,
    flag: 'U+1F1E8 U+1F1EB',
    active: true,
    createdAt: '2024-07-18T17:07:32.757Z',
    updatedAt: '2024-12-19T16:16:05.811Z',
  },
  {
    id: '7811b8f3-6618-44ba-946e-f03e1bf7eb32',
    countryName: 'Chad',
    countryCode: 'TD',
    phoneCode: '+235',
    region: null,
    flag: 'U+1F1F9 U+1F1E9',
    active: true,
    createdAt: '2024-07-18T17:07:32.849Z',
    updatedAt: '2024-12-19T16:16:05.908Z',
  },
  {
    id: '0d9954ea-1b6d-4c42-b57d-1c7a14322874',
    countryName: 'Chile',
    countryCode: 'CL',
    phoneCode: '+56',
    region: null,
    flag: 'U+1F1E8 U+1F1F1',
    active: true,
    createdAt: '2024-07-18T17:07:32.758Z',
    updatedAt: '2024-12-19T16:16:05.812Z',
  },
  {
    id: 'a013c406-0f2a-4f61-bc8c-787eb64e6775',
    countryName: 'China',
    countryCode: 'CN',
    phoneCode: '+86',
    region: null,
    flag: 'U+1F1E8 U+1F1F3',
    active: true,
    createdAt: '2024-07-18T17:07:32.758Z',
    updatedAt: '2024-12-19T16:16:05.812Z',
  },
  {
    id: '19d0108c-6bed-4903-a8d5-18f90ff16909',
    countryName: 'Christmas Island',
    countryCode: 'CX',
    phoneCode: '+61',
    region: null,
    flag: 'U+1F1E8 U+1F1FD',
    active: true,
    createdAt: '2024-07-18T17:07:32.759Z',
    updatedAt: '2024-12-19T16:16:05.814Z',
  },
  {
    id: '5859f165-a418-4a65-9606-388177dca946',
    countryName: 'Cocos (Keeling) Islands',
    countryCode: 'CC',
    phoneCode: '+61',
    region: null,
    flag: 'U+1F1E8 U+1F1E8',
    active: true,
    createdAt: '2024-07-18T17:07:32.756Z',
    updatedAt: '2024-12-19T16:16:05.810Z',
  },
  {
    id: '9955d659-e630-4ea2-aaad-c9010c8b7484',
    countryName: 'Colombia',
    countryCode: 'CO',
    phoneCode: '+57',
    region: null,
    flag: 'U+1F1E8 U+1F1F4',
    active: true,
    createdAt: '2024-07-18T17:07:32.758Z',
    updatedAt: '2024-12-19T16:16:05.813Z',
  },
  {
    id: 'e68c2fde-53c8-484c-9822-301425acd3eb',
    countryName: 'Comoros',
    countryCode: 'KM',
    phoneCode: '+269',
    region: null,
    flag: 'U+1F1F0 U+1F1F2',
    active: true,
    createdAt: '2024-07-18T17:07:32.806Z',
    updatedAt: '2024-12-19T16:16:05.891Z',
  },
  {
    id: 'cd76a946-2496-4084-b6d1-1bdcbef08cd4',
    countryName: 'Congo - Brazzaville',
    countryCode: 'CG',
    phoneCode: '+242',
    region: null,
    flag: 'U+1F1E8 U+1F1EC',
    active: true,
    createdAt: '2024-07-18T17:07:32.757Z',
    updatedAt: '2024-12-19T16:16:05.811Z',
  },
  {
    id: 'ed665b6d-835e-4115-8a48-17a45519d57c',
    countryName: 'Congo - Kinshasa',
    countryCode: 'CD',
    phoneCode: '+243',
    region: null,
    flag: 'U+1F1E8 U+1F1E9',
    active: true,
    createdAt: '2024-07-18T17:07:32.757Z',
    updatedAt: '2024-12-19T16:16:05.811Z',
  },
  {
    id: 'dc14e339-b80d-4860-8c87-6189f528ff2f',
    countryName: 'Cook Islands',
    countryCode: 'CK',
    phoneCode: '+682',
    region: null,
    flag: 'U+1F1E8 U+1F1F0',
    active: true,
    createdAt: '2024-07-18T17:07:32.758Z',
    updatedAt: '2024-12-19T16:16:05.812Z',
  },
  {
    id: '728b06f8-ca91-4e19-908c-5efe02a8c9c2',
    countryName: 'Costa Rica',
    countryCode: 'CR',
    phoneCode: '+506',
    region: null,
    flag: 'U+1F1E8 U+1F1F7',
    active: true,
    createdAt: '2024-07-18T17:07:32.759Z',
    updatedAt: '2024-12-19T16:16:05.813Z',
  },
  {
    id: '8daaccf4-20cd-4f9c-842d-6b1e1a6665fc',
    countryName: 'Cote d Ivoire',
    countryCode: 'CI',
    phoneCode: '+225',
    region: null,
    flag: 'U+1F1E8 U+1F1EE',
    active: true,
    createdAt: '2024-07-18T17:07:32.757Z',
    updatedAt: '2024-12-19T16:16:05.812Z',
  },
  {
    id: '8b8822a4-b687-4937-bbec-b18cb216092a',
    countryName: 'Croatia',
    countryCode: 'HR',
    phoneCode: '+385',
    region: null,
    flag: 'U+1F1ED U+1F1F7',
    active: true,
    createdAt: '2024-07-18T17:07:32.771Z',
    updatedAt: '2024-12-19T16:16:05.822Z',
  },
  {
    id: '5fc91950-0d2b-490d-9b75-333e88f2a621',
    countryName: 'Cuba',
    countryCode: 'CU',
    phoneCode: '+53',
    region: null,
    flag: 'U+1F1E8 U+1F1FA',
    active: true,
    createdAt: '2024-07-18T17:07:32.759Z',
    updatedAt: '2024-12-19T16:16:05.813Z',
  },
  {
    id: 'b8894a8f-c7fc-45e7-a841-89f9e84b72c5',
    countryName: 'Cyprus',
    countryCode: 'CY',
    phoneCode: '+357',
    region: null,
    flag: 'U+1F1E8 U+1F1FE',
    active: true,
    createdAt: '2024-07-18T17:07:32.759Z',
    updatedAt: '2024-12-19T16:16:05.814Z',
  },
  {
    id: '5d65b21e-bb98-4691-8236-528176cae015',
    countryName: 'Czechia',
    countryCode: 'CZ',
    phoneCode: '+420',
    region: null,
    flag: 'U+1F1E8 U+1F1FF',
    active: true,
    createdAt: '2024-07-18T17:07:32.759Z',
    updatedAt: '2024-12-19T16:16:05.814Z',
  },
  {
    id: '80f8a374-d2e3-4361-a3cb-23cec6640bcc',
    countryName: 'Denmark',
    countryCode: 'DK',
    phoneCode: '+45',
    region: null,
    flag: 'U+1F1E9 U+1F1F0',
    active: true,
    createdAt: '2024-07-18T17:07:32.760Z',
    updatedAt: '2024-12-19T16:16:05.815Z',
  },
  {
    id: 'bcf82633-4a59-4eda-8b9e-fd88b15b362f',
    countryName: 'Djibouti',
    countryCode: 'DJ',
    phoneCode: '+253',
    region: null,
    flag: 'U+1F1E9 U+1F1EF',
    active: true,
    createdAt: '2024-07-18T17:07:32.760Z',
    updatedAt: '2024-12-19T16:16:05.814Z',
  },
  {
    id: '368d1a1a-9604-4412-b90d-6d37582108fd',
    countryName: 'Dominica',
    countryCode: 'DM',
    phoneCode: '+1767',
    region: null,
    flag: 'U+1F1E9 U+1F1F2',
    active: true,
    createdAt: '2024-07-18T17:07:32.762Z',
    updatedAt: '2024-12-19T16:16:05.815Z',
  },
  {
    id: '9017a035-17c3-401a-aa0f-8950f3255666',
    countryName: 'Dominican Republic',
    countryCode: 'DO',
    phoneCode: '+1849',
    region: null,
    flag: 'U+1F1E9 U+1F1F4',
    active: true,
    createdAt: '2024-07-18T17:07:32.762Z',
    updatedAt: '2024-12-19T16:16:05.815Z',
  },
  {
    id: 'ce383310-b128-4c75-892b-78dd1fb617d0',
    countryName: 'Ecuador',
    countryCode: 'EC',
    phoneCode: '+593',
    region: null,
    flag: 'U+1F1EA U+1F1E8',
    active: true,
    createdAt: '2024-07-18T17:07:32.763Z',
    updatedAt: '2024-12-19T16:16:05.815Z',
  },
  {
    id: 'cc754f57-155b-4734-a789-82575860d8a0',
    countryName: 'Egypt',
    countryCode: 'EG',
    phoneCode: '+20',
    region: null,
    flag: 'U+1F1EA U+1F1EC',
    active: true,
    createdAt: '2024-07-18T17:07:32.763Z',
    updatedAt: '2024-12-19T16:16:05.816Z',
  },
  {
    id: '42599161-50fa-4122-8cbe-c46ec5c768e3',
    countryName: 'El Salvador',
    countryCode: 'SV',
    phoneCode: '+503',
    region: null,
    flag: 'U+1F1F8 U+1F1FB',
    active: true,
    createdAt: '2024-07-18T17:07:32.849Z',
    updatedAt: '2024-12-19T16:16:05.908Z',
  },
  {
    id: '50edf828-4b9d-48e3-948d-25a370bb1e1f',
    countryName: 'Equatorial Guinea',
    countryCode: 'GQ',
    phoneCode: '+240',
    region: null,
    flag: 'U+1F1EC U+1F1F6',
    active: true,
    createdAt: '2024-07-18T17:07:32.770Z',
    updatedAt: '2024-12-19T16:16:05.820Z',
  },
  {
    id: 'fe25db65-00e8-45d9-9ece-d387d0f1ebd4',
    countryName: 'Eritrea',
    countryCode: 'ER',
    phoneCode: '+291',
    region: null,
    flag: 'U+1F1EA U+1F1F7',
    active: true,
    createdAt: '2024-07-18T17:07:32.766Z',
    updatedAt: '2024-12-19T16:16:05.816Z',
  },
  {
    id: '6428fbdf-da16-47d2-8d28-e5b15e27e8ad',
    countryName: 'Estonia',
    countryCode: 'EE',
    phoneCode: '+372',
    region: null,
    flag: 'U+1F1EA U+1F1EA',
    active: true,
    createdAt: '2024-07-18T17:07:32.763Z',
    updatedAt: '2024-12-19T16:16:05.815Z',
  },
  {
    id: 'bb3d60de-d7ca-41c1-b32e-d2365c7b12c6',
    countryName: 'Eswatini',
    countryCode: 'SZ',
    phoneCode: '+268',
    region: null,
    flag: 'U+1F1F8 U+1F1FF',
    active: true,
    createdAt: '2024-07-18T17:07:32.849Z',
    updatedAt: '2024-12-19T16:16:05.908Z',
  },
  {
    id: '61e4eedc-2905-4fd9-a3b9-b464c4195de1',
    countryName: 'Ethiopia',
    countryCode: 'ET',
    phoneCode: '+251',
    region: null,
    flag: 'U+1F1EA U+1F1F9',
    active: true,
    createdAt: '2024-07-18T17:07:32.766Z',
    updatedAt: '2024-12-19T16:16:05.816Z',
  },
  {
    id: '00cf1f4b-0c29-4585-bba7-e98410437ed5',
    countryName: 'Falkland Islands',
    countryCode: 'FK',
    phoneCode: '+500',
    region: null,
    flag: 'U+1F1EB U+1F1F0',
    active: true,
    createdAt: '2024-07-18T17:07:32.767Z',
    updatedAt: '2024-12-19T16:16:05.817Z',
  },
  {
    id: 'b2e2285f-638a-46bd-afc4-82a54d9e203e',
    countryName: 'Faroe Islands',
    countryCode: 'FO',
    phoneCode: '+298',
    region: null,
    flag: 'U+1F1EB U+1F1F4',
    active: true,
    createdAt: '2024-07-18T17:07:32.767Z',
    updatedAt: '2024-12-19T16:16:05.817Z',
  },
  {
    id: 'aa675532-8b60-473e-9048-f193b6c99bdd',
    countryName: 'Fiji',
    countryCode: 'FJ',
    phoneCode: '+679',
    region: null,
    flag: 'U+1F1EB U+1F1EF',
    active: true,
    createdAt: '2024-07-18T17:07:32.767Z',
    updatedAt: '2024-12-19T16:16:05.817Z',
  },
  {
    id: 'cbe9377f-6287-413e-a548-a22253df1131',
    countryName: 'Finland',
    countryCode: 'FI',
    phoneCode: '+358',
    region: null,
    flag: 'U+1F1EB U+1F1EE',
    active: true,
    createdAt: '2024-07-18T17:07:32.766Z',
    updatedAt: '2024-12-19T16:16:05.816Z',
  },
  {
    id: '9c35ecbc-58ae-4ba6-8bd1-7a8b419724e6',
    countryName: 'France',
    countryCode: 'FR',
    phoneCode: '+33',
    region: null,
    flag: 'U+1F1EB U+1F1F7',
    active: true,
    createdAt: '2024-07-18T17:07:32.767Z',
    updatedAt: '2024-12-19T16:16:05.818Z',
  },
  {
    id: '6f25db75-eadf-4360-bd3e-85cfc796a179',
    countryName: 'French Guiana',
    countryCode: 'GF',
    phoneCode: '+594',
    region: null,
    flag: 'U+1F1EC U+1F1EB',
    active: true,
    createdAt: '2024-07-18T17:07:32.768Z',
    updatedAt: '2024-12-19T16:16:05.819Z',
  },
  {
    id: '85518e43-c8ec-4fa2-955e-7a06355a703a',
    countryName: 'French Polynesia',
    countryCode: 'PF',
    phoneCode: '+689',
    region: null,
    flag: 'U+1F1F5 U+1F1EB',
    active: true,
    createdAt: '2024-07-18T17:07:32.834Z',
    updatedAt: '2024-12-19T16:16:05.902Z',
  },
  {
    id: 'eb5115c4-166b-44fa-9151-23b09560b648',
    countryName: 'Gabon',
    countryCode: 'GA',
    phoneCode: '+241',
    region: null,
    flag: 'U+1F1EC U+1F1E6',
    active: true,
    createdAt: '2024-07-18T17:07:32.768Z',
    updatedAt: '2024-12-19T16:16:05.818Z',
  },
  {
    id: '15db7df9-50bb-42f3-8f36-64077d311ef2',
    countryName: 'Gambia',
    countryCode: 'GM',
    phoneCode: '+220',
    region: null,
    flag: 'U+1F1EC U+1F1F2',
    active: true,
    createdAt: '2024-07-18T17:07:32.769Z',
    updatedAt: '2024-12-19T16:16:05.820Z',
  },
  {
    id: 'c77ce8f1-dc74-40c1-9d46-1c0b1505a254',
    countryName: 'Georgia',
    countryCode: 'GE',
    phoneCode: '+995',
    region: null,
    flag: 'U+1F1EC U+1F1EA',
    active: true,
    createdAt: '2024-07-18T17:07:32.768Z',
    updatedAt: '2024-12-19T16:16:05.819Z',
  },
  {
    id: 'f3ca5f15-5ab4-4af3-aeff-a107e0b79dc6',
    countryName: 'Germany',
    countryCode: 'DE',
    phoneCode: '+49',
    region: null,
    flag: 'U+1F1E9 U+1F1EA',
    active: true,
    createdAt: '2024-07-18T17:07:32.760Z',
    updatedAt: '2024-12-19T16:16:05.814Z',
  },
  {
    id: '84ba08ef-ff50-4417-8b9a-62244fa38516',
    countryName: 'Ghana',
    countryCode: 'GH',
    phoneCode: '+233',
    region: null,
    flag: 'U+1F1EC U+1F1ED',
    active: true,
    createdAt: '2024-07-18T17:07:32.769Z',
    updatedAt: '2024-12-19T16:16:05.819Z',
  },
  {
    id: '10539b68-9e23-4b85-b37e-e22de8639741',
    countryName: 'Gibraltar',
    countryCode: 'GI',
    phoneCode: '+350',
    region: null,
    flag: 'U+1F1EC U+1F1EE',
    active: true,
    createdAt: '2024-07-18T17:07:32.769Z',
    updatedAt: '2024-12-19T16:16:05.819Z',
  },
  {
    id: '702eef5b-70fc-4804-8227-3d2566d51c17',
    countryName: 'Greece',
    countryCode: 'GR',
    phoneCode: '+30',
    region: null,
    flag: 'U+1F1EC U+1F1F7',
    active: true,
    createdAt: '2024-07-18T17:07:32.770Z',
    updatedAt: '2024-12-19T16:16:05.821Z',
  },
  {
    id: '1baa4da3-65a4-4f1a-9834-e8226a5f33ff',
    countryName: 'Greenland',
    countryCode: 'GL',
    phoneCode: '+299',
    region: null,
    flag: 'U+1F1EC U+1F1F1',
    active: true,
    createdAt: '2024-07-18T17:07:32.769Z',
    updatedAt: '2024-12-19T16:16:05.820Z',
  },
  {
    id: '9ee08e76-f09f-42b7-bbab-f78de63492d8',
    countryName: 'Grenada',
    countryCode: 'GD',
    phoneCode: '+1473',
    region: null,
    flag: 'U+1F1EC U+1F1E9',
    active: true,
    createdAt: '2024-07-18T17:07:32.768Z',
    updatedAt: '2024-12-19T16:16:05.819Z',
  },
  {
    id: '500d267e-fa6f-47d1-9fdf-cae2de77127e',
    countryName: 'Guadeloupe',
    countryCode: 'GP',
    phoneCode: '+590',
    region: null,
    flag: 'U+1F1EC U+1F1F5',
    active: true,
    createdAt: '2024-07-18T17:07:32.769Z',
    updatedAt: '2024-12-19T16:16:05.820Z',
  },
  {
    id: '578e88e7-dbd2-4d4e-bdf7-5bf07d394a52',
    countryName: 'Guam',
    countryCode: 'GU',
    phoneCode: '+1671',
    region: null,
    flag: 'U+1F1EC U+1F1FA',
    active: true,
    createdAt: '2024-07-18T17:07:32.770Z',
    updatedAt: '2024-12-19T16:16:05.821Z',
  },
  {
    id: 'e834ba62-2f6b-429e-9383-7125c2425982',
    countryName: 'Guatemala',
    countryCode: 'GT',
    phoneCode: '+502',
    region: null,
    flag: 'U+1F1EC U+1F1F9',
    active: true,
    createdAt: '2024-07-18T17:07:32.770Z',
    updatedAt: '2024-12-19T16:16:05.821Z',
  },
  {
    id: 'dd093e6e-5414-4972-8a70-b44e272b40a9',
    countryName: 'Guernsey',
    countryCode: 'GG',
    phoneCode: '+44',
    region: null,
    flag: 'U+1F1EC U+1F1EC',
    active: true,
    createdAt: '2024-07-18T17:07:32.768Z',
    updatedAt: '2024-12-19T16:16:05.819Z',
  },
  {
    id: '40f50f3e-b8bd-4ed0-a39e-ce277be3e344',
    countryName: 'Guinea',
    countryCode: 'GN',
    phoneCode: '+224',
    region: null,
    flag: 'U+1F1EC U+1F1F3',
    active: true,
    createdAt: '2024-07-18T17:07:32.769Z',
    updatedAt: '2024-12-19T16:16:05.820Z',
  },
  {
    id: 'bcafa1ef-b579-4e17-a44d-3930bb64b31f',
    countryName: 'Guinea-Bissau',
    countryCode: 'GW',
    phoneCode: '+245',
    region: null,
    flag: 'U+1F1EC U+1F1FC',
    active: true,
    createdAt: '2024-07-18T17:07:32.771Z',
    updatedAt: '2024-12-19T16:16:05.821Z',
  },
  {
    id: '05497627-984d-48b9-8a90-81d406e91b2b',
    countryName: 'Guyana',
    countryCode: 'GY',
    phoneCode: '+595',
    region: null,
    flag: 'U+1F1EC U+1F1FE',
    active: true,
    createdAt: '2024-07-18T17:07:32.771Z',
    updatedAt: '2024-12-19T16:16:05.821Z',
  },
  {
    id: '77688d21-bc45-4266-b2b7-50d7ddd2eea8',
    countryName: 'Haiti',
    countryCode: 'HT',
    phoneCode: '+509',
    region: null,
    flag: 'U+1F1ED U+1F1F9',
    active: true,
    createdAt: '2024-07-18T17:07:32.772Z',
    updatedAt: '2024-12-19T16:16:05.822Z',
  },
  {
    id: 'fb2fb48b-06a6-46b9-a982-f02ebc230bed',
    countryName: 'Honduras',
    countryCode: 'HN',
    phoneCode: '+504',
    region: null,
    flag: 'U+1F1ED U+1F1F3',
    active: true,
    createdAt: '2024-07-18T17:07:32.771Z',
    updatedAt: '2024-12-19T16:16:05.822Z',
  },
  {
    id: '0487a35d-7d12-4e20-8610-06b32aa1285f',
    countryName: 'Hong Kong SAR China',
    countryCode: 'HK',
    phoneCode: '+852',
    region: null,
    flag: 'U+1F1ED U+1F1F0',
    active: true,
    createdAt: '2024-07-18T17:07:32.771Z',
    updatedAt: '2024-12-19T16:16:05.822Z',
  },
  {
    id: 'cf49f738-070f-458c-8fd4-8121a34b49ce',
    countryName: 'Hungary',
    countryCode: 'HU',
    phoneCode: '+36',
    region: null,
    flag: 'U+1F1ED U+1F1FA',
    active: true,
    createdAt: '2024-07-18T17:07:32.772Z',
    updatedAt: '2024-12-19T16:16:05.822Z',
  },
  {
    id: '6ce1a067-0afa-4dc1-8c0f-efcfe920360b',
    countryName: 'Iceland',
    countryCode: 'IS',
    phoneCode: '+354',
    region: null,
    flag: 'U+1F1EE U+1F1F8',
    active: true,
    createdAt: '2024-07-18T17:07:32.804Z',
    updatedAt: '2024-12-19T16:16:05.828Z',
  },
  {
    id: '52a549a4-468b-42f8-97d5-be450924daca',
    countryName: 'India',
    countryCode: 'IN',
    phoneCode: '+91',
    region: null,
    flag: 'U+1F1EE U+1F1F3',
    active: true,
    createdAt: '2024-07-18T17:07:32.804Z',
    updatedAt: '2024-12-19T16:16:05.826Z',
  },
  {
    id: '929b4fe6-8280-4c9f-9a10-d4cbc07be697',
    countryName: 'Indonesia',
    countryCode: 'ID',
    phoneCode: '+62',
    region: null,
    flag: 'U+1F1EE U+1F1E9',
    active: true,
    createdAt: '2024-07-18T17:07:32.772Z',
    updatedAt: '2024-12-19T16:16:05.822Z',
  },
  {
    id: 'e9fbd092-a902-498d-9be5-230d6f491dd2',
    countryName: 'Iran',
    countryCode: 'IR',
    phoneCode: '+98',
    region: null,
    flag: 'U+1F1EE U+1F1F7',
    active: true,
    createdAt: '2024-07-18T17:07:32.804Z',
    updatedAt: '2024-12-19T16:16:05.827Z',
  },
  {
    id: 'a9c50730-56df-4220-b341-a16490c9aaf5',
    countryName: 'Iraq',
    countryCode: 'IQ',
    phoneCode: '+964',
    region: null,
    flag: 'U+1F1EE U+1F1F6',
    active: true,
    createdAt: '2024-07-18T17:07:32.804Z',
    updatedAt: '2024-12-19T16:16:05.827Z',
  },
  {
    id: 'e7db047f-ad35-4fc3-bdde-6b6838e93ef4',
    countryName: 'Ireland',
    countryCode: 'IE',
    phoneCode: '+353',
    region: null,
    flag: 'U+1F1EE U+1F1EA',
    active: true,
    createdAt: '2024-07-18T17:07:32.772Z',
    updatedAt: '2024-12-19T16:16:05.822Z',
  },
  {
    id: '81d1e63b-3591-401b-aad5-6e1999eeea30',
    countryName: 'Isle of Man',
    countryCode: 'IM',
    phoneCode: '+44',
    region: null,
    flag: 'U+1F1EE U+1F1F2',
    active: true,
    createdAt: '2024-07-18T17:07:32.798Z',
    updatedAt: '2024-12-19T16:16:05.823Z',
  },
  {
    id: 'f71e51c9-3906-4e5f-a25e-324a08abb554',
    countryName: 'Israel',
    countryCode: 'IL',
    phoneCode: '+972',
    region: null,
    flag: 'U+1F1EE U+1F1F1',
    active: true,
    createdAt: '2024-07-18T17:07:32.772Z',
    updatedAt: '2024-12-19T16:16:05.823Z',
  },
  {
    id: '4935641b-c223-4cbd-b110-6a79a5ede12c',
    countryName: 'Italy',
    countryCode: 'IT',
    phoneCode: '+39',
    region: null,
    flag: 'U+1F1EE U+1F1F9',
    active: true,
    createdAt: '2024-07-18T17:07:32.804Z',
    updatedAt: '2024-12-19T16:16:05.888Z',
  },
  {
    id: 'b1bf16b4-4358-4f25-8591-816bf6ee452e',
    countryName: 'Jamaica',
    countryCode: 'JM',
    phoneCode: '+1876',
    region: null,
    flag: 'U+1F1EF U+1F1F2',
    active: true,
    createdAt: '2024-07-18T17:07:32.805Z',
    updatedAt: '2024-12-19T16:16:05.889Z',
  },
  {
    id: '190d9f6a-f7fe-4f9b-bc08-a40fa67fcb9e',
    countryName: 'Japan',
    countryCode: 'JP',
    phoneCode: '+81',
    region: null,
    flag: 'U+1F1EF U+1F1F5',
    active: true,
    createdAt: '2024-07-18T17:07:32.805Z',
    updatedAt: '2024-12-19T16:16:05.889Z',
  },
  {
    id: 'ec46e574-e3ef-45df-9bfd-71fd737ce906',
    countryName: 'Jersey',
    countryCode: 'JE',
    phoneCode: '+44',
    region: null,
    flag: 'U+1F1EF U+1F1EA',
    active: true,
    createdAt: '2024-07-18T17:07:32.805Z',
    updatedAt: '2024-12-19T16:16:05.889Z',
  },
  {
    id: '3cacb28a-e833-4b1a-9086-500944129e9f',
    countryName: 'Jordan',
    countryCode: 'JO',
    phoneCode: '+962',
    region: null,
    flag: 'U+1F1EF U+1F1F4',
    active: true,
    createdAt: '2024-07-18T17:07:32.805Z',
    updatedAt: '2024-12-19T16:16:05.889Z',
  },
  {
    id: '8354437e-ec8e-49c0-a4b3-a1493eb359d4',
    countryName: 'Kazakhstan',
    countryCode: 'KZ',
    phoneCode: '+77',
    region: null,
    flag: 'U+1F1F0 U+1F1FF',
    active: true,
    createdAt: '2024-07-18T17:07:32.806Z',
    updatedAt: '2024-12-19T16:16:05.892Z',
  },
  {
    id: '43e338a4-ce5d-470e-a080-130725d4088d',
    countryName: 'Kenya',
    countryCode: 'KE',
    phoneCode: '+254',
    region: null,
    flag: 'U+1F1F0 U+1F1EA',
    active: true,
    createdAt: '2024-07-18T17:07:32.805Z',
    updatedAt: '2024-12-19T16:16:05.890Z',
  },
  {
    id: 'e3de1083-c205-4cf5-a0f2-8aab261d5e9a',
    countryName: 'Kiribati',
    countryCode: 'KI',
    phoneCode: '+686',
    region: null,
    flag: 'U+1F1F0 U+1F1EE',
    active: true,
    createdAt: '2024-07-18T17:07:32.805Z',
    updatedAt: '2024-12-19T16:16:05.891Z',
  },
  {
    id: 'c25a5cd2-a74a-4eb5-a5aa-d2f8b4d7a800',
    countryName: 'Kuwait',
    countryCode: 'KW',
    phoneCode: '+965',
    region: null,
    flag: 'U+1F1F0 U+1F1FC',
    active: true,
    createdAt: '2024-07-18T17:07:32.806Z',
    updatedAt: '2024-12-19T16:16:05.892Z',
  },
  {
    id: '661857aa-09a4-48e4-bc5a-c7d0b195d0c3',
    countryName: 'Kyrgyzstan',
    countryCode: 'KG',
    phoneCode: '+996',
    region: null,
    flag: 'U+1F1F0 U+1F1EC',
    active: true,
    createdAt: '2024-07-18T17:07:32.805Z',
    updatedAt: '2024-12-19T16:16:05.890Z',
  },
  {
    id: 'bd8af998-d8e8-4f5f-b24e-257b69137dc0',
    countryName: 'Laos',
    countryCode: 'LA',
    phoneCode: '+856',
    region: null,
    flag: 'U+1F1F1 U+1F1E6',
    active: true,
    createdAt: '2024-07-18T17:07:32.807Z',
    updatedAt: '2024-12-19T16:16:05.892Z',
  },
  {
    id: 'ded67f44-dd2d-4f4e-9c25-706ccc9483d3',
    countryName: 'Latvia',
    countryCode: 'LV',
    phoneCode: '+371',
    region: null,
    flag: 'U+1F1F1 U+1F1FB',
    active: true,
    createdAt: '2024-07-18T17:07:32.808Z',
    updatedAt: '2024-12-19T16:16:05.894Z',
  },
  {
    id: 'd87d6999-f3a8-48c3-8978-2c8bbf22cfcd',
    countryName: 'Lebanon',
    countryCode: 'LB',
    phoneCode: '+961',
    region: null,
    flag: 'U+1F1F1 U+1F1E7',
    active: true,
    createdAt: '2024-07-18T17:07:32.807Z',
    updatedAt: '2024-12-19T16:16:05.892Z',
  },
  {
    id: '98249ffa-04a1-4f53-9ba4-86a67837adf7',
    countryName: 'Lesotho',
    countryCode: 'LS',
    phoneCode: '+266',
    region: null,
    flag: 'U+1F1F1 U+1F1F8',
    active: true,
    createdAt: '2024-07-18T17:07:32.808Z',
    updatedAt: '2024-12-19T16:16:05.893Z',
  },
  {
    id: '902a558e-9ab9-4c5f-9dba-07d612fca1c6',
    countryName: 'Liberia',
    countryCode: 'LR',
    phoneCode: '+231',
    region: null,
    flag: 'U+1F1F1 U+1F1F7',
    active: true,
    createdAt: '2024-07-18T17:07:32.807Z',
    updatedAt: '2024-12-19T16:16:05.893Z',
  },
  {
    id: '7c234796-082d-4ae6-9c19-3b6df7e44748',
    countryName: 'Libya',
    countryCode: 'LY',
    phoneCode: '+218',
    region: null,
    flag: 'U+1F1F1 U+1F1FE',
    active: true,
    createdAt: '2024-07-18T17:07:32.808Z',
    updatedAt: '2024-12-19T16:16:05.894Z',
  },
  {
    id: '98adf4b6-c563-48e0-baf5-0d26b2da2bb8',
    countryName: 'Liechtenstein',
    countryCode: 'LI',
    phoneCode: '+423',
    region: null,
    flag: 'U+1F1F1 U+1F1EE',
    active: true,
    createdAt: '2024-07-18T17:07:32.807Z',
    updatedAt: '2024-12-19T16:16:05.893Z',
  },
  {
    id: '03a42e13-6f3e-4380-b236-eb42a60f43a1',
    countryName: 'Lithuania',
    countryCode: 'LT',
    phoneCode: '+370',
    region: null,
    flag: 'U+1F1F1 U+1F1F9',
    active: true,
    createdAt: '2024-07-18T17:07:32.808Z',
    updatedAt: '2024-12-19T16:16:05.893Z',
  },
  {
    id: '3d5b47ac-63e1-4a25-998b-9c7ae2798962',
    countryName: 'Luxembourg',
    countryCode: 'LU',
    phoneCode: '+352',
    region: null,
    flag: 'U+1F1F1 U+1F1FA',
    active: true,
    createdAt: '2024-07-18T17:07:32.808Z',
    updatedAt: '2024-12-19T16:16:05.893Z',
  },
  {
    id: 'dab84315-b629-415e-ae19-8995a5ebf3bb',
    countryName: 'Macao SAR China',
    countryCode: 'MO',
    phoneCode: '+853',
    region: null,
    flag: 'U+1F1F2 U+1F1F4',
    active: true,
    createdAt: '2024-07-18T17:07:32.813Z',
    updatedAt: '2024-12-19T16:16:05.896Z',
  },
  {
    id: 'c1791ac8-086c-47d3-9859-c2062f48f7c2',
    countryName: 'Madagascar',
    countryCode: 'MG',
    phoneCode: '+261',
    region: null,
    flag: 'U+1F1F2 U+1F1EC',
    active: true,
    createdAt: '2024-07-18T17:07:32.812Z',
    updatedAt: '2024-12-19T16:16:05.895Z',
  },
  {
    id: 'd6002d14-4c3a-4349-8386-777ebfb5e2ac',
    countryName: 'Malawi',
    countryCode: 'MW',
    phoneCode: '+265',
    region: null,
    flag: 'U+1F1F2 U+1F1FC',
    active: true,
    createdAt: '2024-07-18T17:07:32.817Z',
    updatedAt: '2024-12-19T16:16:05.897Z',
  },
  {
    id: '61df01af-0fff-43ec-8ada-3c1b0f81f0e8',
    countryName: 'Malaysia',
    countryCode: 'MY',
    phoneCode: '+60',
    region: null,
    flag: 'U+1F1F2 U+1F1FE',
    active: true,
    createdAt: '2024-07-18T17:07:32.817Z',
    updatedAt: '2024-12-19T16:16:05.898Z',
  },
  {
    id: '1b669b8b-ff54-4cd8-8ad2-29df289035f2',
    countryName: 'Maldives',
    countryCode: 'MV',
    phoneCode: '+960',
    region: null,
    flag: 'U+1F1F2 U+1F1FB',
    active: true,
    createdAt: '2024-07-18T17:07:32.817Z',
    updatedAt: '2024-12-19T16:16:05.897Z',
  },
  {
    id: '888a8659-0cbc-414b-9514-6b01015818be',
    countryName: 'Mali',
    countryCode: 'ML',
    phoneCode: '+223',
    region: null,
    flag: 'U+1F1F2 U+1F1F1',
    active: true,
    createdAt: '2024-07-18T17:07:32.813Z',
    updatedAt: '2024-12-19T16:16:05.895Z',
  },
  {
    id: 'fa194f1b-11fa-44f2-9936-1fd2cdc0fac2',
    countryName: 'Malta',
    countryCode: 'MT',
    phoneCode: '+356',
    region: null,
    flag: 'U+1F1F2 U+1F1F9',
    active: true,
    createdAt: '2024-07-18T17:07:32.817Z',
    updatedAt: '2024-12-19T16:16:05.897Z',
  },
  {
    id: 'd0b129b0-dd9f-4c3f-aca6-671114027591',
    countryName: 'Marshall Islands',
    countryCode: 'MH',
    phoneCode: '+692',
    region: null,
    flag: 'U+1F1F2 U+1F1ED',
    active: true,
    createdAt: '2024-07-18T17:07:32.812Z',
    updatedAt: '2024-12-19T16:16:05.895Z',
  },
  {
    id: '0bfbf68e-9d84-46ec-90a5-cc9e6f3d5269',
    countryName: 'Martinique',
    countryCode: 'MQ',
    phoneCode: '+596',
    region: null,
    flag: 'U+1F1F2 U+1F1F6',
    active: true,
    createdAt: '2024-07-18T17:07:32.813Z',
    updatedAt: '2024-12-19T16:16:05.896Z',
  },
  {
    id: '62a05907-8a70-44bf-aeb6-3397afbde958',
    countryName: 'Mauritania',
    countryCode: 'MR',
    phoneCode: '+222',
    region: null,
    flag: 'U+1F1F2 U+1F1F7',
    active: true,
    createdAt: '2024-07-18T17:07:32.816Z',
    updatedAt: '2024-12-19T16:16:05.897Z',
  },
  {
    id: '30f3134b-d209-4efc-88f2-1a040ddb5be7',
    countryName: 'Mauritius',
    countryCode: 'MU',
    phoneCode: '+230',
    region: null,
    flag: 'U+1F1F2 U+1F1FA',
    active: true,
    createdAt: '2024-07-18T17:07:32.817Z',
    updatedAt: '2024-12-19T16:16:05.897Z',
  },
  {
    id: '583f28d8-58f3-4777-8095-2573d72d81ca',
    countryName: 'Mayotte',
    countryCode: 'YT',
    phoneCode: '+262',
    region: null,
    flag: 'U+1F1FE U+1F1F9',
    active: true,
    createdAt: '2024-07-18T17:07:32.859Z',
    updatedAt: '2024-12-19T16:16:05.915Z',
  },
  {
    id: '3af69446-e2db-424a-8eff-7f288fd52f4c',
    countryName: 'Mexico',
    countryCode: 'MX',
    phoneCode: '+52',
    region: null,
    flag: 'U+1F1F2 U+1F1FD',
    active: true,
    createdAt: '2024-07-18T17:07:32.817Z',
    updatedAt: '2024-12-19T16:16:05.898Z',
  },
  {
    id: 'b5f1d207-a0c7-406d-a85f-91b3062fbdca',
    countryName: 'Micronesia',
    countryCode: 'FM',
    phoneCode: '+691',
    region: null,
    flag: 'U+1F1EB U+1F1F2',
    active: true,
    createdAt: '2024-07-18T17:07:32.767Z',
    updatedAt: '2024-12-19T16:16:05.817Z',
  },
  {
    id: '7d9d056e-3fea-41c9-9ce5-ebfb52168a4c',
    countryName: 'Moldova',
    countryCode: 'MD',
    phoneCode: '+373',
    region: null,
    flag: 'U+1F1F2 U+1F1E9',
    active: true,
    createdAt: '2024-07-18T17:07:32.812Z',
    updatedAt: '2024-12-19T16:16:05.894Z',
  },
  {
    id: 'c76dca70-8afd-4d51-aac0-81ee23894cb0',
    countryName: 'Monaco',
    countryCode: 'MC',
    phoneCode: '+377',
    region: null,
    flag: 'U+1F1F2 U+1F1E8',
    active: true,
    createdAt: '2024-07-18T17:07:32.812Z',
    updatedAt: '2024-12-19T16:16:05.894Z',
  },
  {
    id: 'e15e8e4f-0228-4186-9760-ae97367ffef2',
    countryName: 'Mongolia',
    countryCode: 'MN',
    phoneCode: '+976',
    region: null,
    flag: 'U+1F1F2 U+1F1F3',
    active: true,
    createdAt: '2024-07-18T17:07:32.813Z',
    updatedAt: '2024-12-19T16:16:05.896Z',
  },
  {
    id: '81a29899-2193-4029-9da0-4cc7afc1e366',
    countryName: 'Montenegro',
    countryCode: 'ME',
    phoneCode: '+382',
    region: null,
    flag: 'U+1F1F2 U+1F1EA',
    active: true,
    createdAt: '2024-07-18T17:07:32.812Z',
    updatedAt: '2024-12-19T16:16:05.894Z',
  },
  {
    id: 'a479dbe4-2847-4714-bd77-ea0d29a195ef',
    countryName: 'Montserrat',
    countryCode: 'MS',
    phoneCode: '+1664',
    region: null,
    flag: 'U+1F1F2 U+1F1F8',
    active: true,
    createdAt: '2024-07-18T17:07:32.817Z',
    updatedAt: '2024-12-19T16:16:05.897Z',
  },
  {
    id: '488fc896-05b0-4c2e-95f5-4727d02460b0',
    countryName: 'Morocco',
    countryCode: 'MA',
    phoneCode: '+212',
    region: null,
    flag: 'U+1F1F2 U+1F1E6',
    active: true,
    createdAt: '2024-07-18T17:07:32.811Z',
    updatedAt: '2024-12-19T16:16:05.894Z',
  },
  {
    id: '3b4ee8c8-8b46-4ccc-b84a-92001fce5ff5',
    countryName: 'Mozambique',
    countryCode: 'MZ',
    phoneCode: '+258',
    region: null,
    flag: 'U+1F1F2 U+1F1FF',
    active: true,
    createdAt: '2024-07-18T17:07:32.817Z',
    updatedAt: '2024-12-19T16:16:05.898Z',
  },
  {
    id: '4975088e-36eb-46da-984b-320d5c19a087',
    countryName: 'Myanmar (Burma)',
    countryCode: 'MM',
    phoneCode: '+95',
    region: null,
    flag: 'U+1F1F2 U+1F1F2',
    active: true,
    createdAt: '2024-07-18T17:07:32.813Z',
    updatedAt: '2024-12-19T16:16:05.895Z',
  },
  {
    id: '83059c62-c047-4d76-a6ee-c3307bd4a212',
    countryName: 'Namibia',
    countryCode: 'NA',
    phoneCode: '+264',
    region: null,
    flag: 'U+1F1F3 U+1F1E6',
    active: true,
    createdAt: '2024-07-18T17:07:32.818Z',
    updatedAt: '2024-12-19T16:16:05.898Z',
  },
  {
    id: 'fa7a5c3b-7e9a-4523-9875-62507ed5fdb8',
    countryName: 'Nauru',
    countryCode: 'NR',
    phoneCode: '+674',
    region: null,
    flag: 'U+1F1F3 U+1F1F7',
    active: true,
    createdAt: '2024-07-18T17:07:32.833Z',
    updatedAt: '2024-12-19T16:16:05.901Z',
  },
  {
    id: '9d2301e7-ee91-4d1c-87dd-735592d24104',
    countryName: 'Nepal',
    countryCode: 'NP',
    phoneCode: '+977',
    region: null,
    flag: 'U+1F1F3 U+1F1F5',
    active: true,
    createdAt: '2024-07-18T17:07:32.833Z',
    updatedAt: '2024-12-19T16:16:05.901Z',
  },
  {
    id: '3856e60b-ac84-48f4-bab0-12427b77da7b',
    countryName: 'Netherlands',
    countryCode: 'NL',
    phoneCode: '+31',
    region: null,
    flag: 'U+1F1F3 U+1F1F1',
    active: true,
    createdAt: '2024-07-18T17:07:32.832Z',
    updatedAt: '2024-12-19T16:16:05.900Z',
  },
  {
    id: '76a6664a-5a4d-4f8c-9e4b-1954af9bffcd',
    countryName: 'New Caledonia',
    countryCode: 'NC',
    phoneCode: '+687',
    region: null,
    flag: 'U+1F1F3 U+1F1E8',
    active: true,
    createdAt: '2024-07-18T17:07:32.818Z',
    updatedAt: '2024-12-19T16:16:05.898Z',
  },
  {
    id: 'b29ed267-4bb8-445c-a9a4-a01c5e10ff61',
    countryName: 'New Zealand',
    countryCode: 'NZ',
    phoneCode: '+64',
    region: null,
    flag: 'U+1F1F3 U+1F1FF',
    active: true,
    createdAt: '2024-07-18T17:07:32.833Z',
    updatedAt: '2024-12-19T16:16:05.902Z',
  },
  {
    id: 'd52c2b62-12ae-4ea2-9c38-ea13a419eb5d',
    countryName: 'Nicaragua',
    countryCode: 'NI',
    phoneCode: '+505',
    region: null,
    flag: 'U+1F1F3 U+1F1EE',
    active: true,
    createdAt: '2024-07-18T17:07:32.832Z',
    updatedAt: '2024-12-19T16:16:05.899Z',
  },
  {
    id: '13080d8c-1daf-4697-b32f-4c9c667a40d5',
    countryName: 'Niger',
    countryCode: 'NE',
    phoneCode: '+227',
    region: null,
    flag: 'U+1F1F3 U+1F1EA',
    active: true,
    createdAt: '2024-07-18T17:07:32.818Z',
    updatedAt: '2024-12-19T16:16:05.898Z',
  },
  {
    id: '833c83f0-a32b-4eeb-bf7a-7313e27f2825',
    countryName: 'Nigeria',
    countryCode: 'NG',
    phoneCode: '+234',
    region: null,
    flag: 'U+1F1F3 U+1F1EC',
    active: true,
    createdAt: '2024-07-18T17:07:32.818Z',
    updatedAt: '2024-12-19T16:16:05.899Z',
  },
  {
    id: 'd68594c2-e622-4abf-9aa4-2d9d3dbc7401',
    countryName: 'Niue',
    countryCode: 'NU',
    phoneCode: '+683',
    region: null,
    flag: 'U+1F1F3 U+1F1FA',
    active: true,
    createdAt: '2024-07-18T17:07:32.833Z',
    updatedAt: '2024-12-19T16:16:05.902Z',
  },
  {
    id: 'edc23ae7-44f5-4c43-83ed-0e85b12c29ae',
    countryName: 'Norfolk Island',
    countryCode: 'NF',
    phoneCode: '+672',
    region: null,
    flag: 'U+1F1F3 U+1F1EB',
    active: true,
    createdAt: '2024-07-18T17:07:32.818Z',
    updatedAt: '2024-12-19T16:16:05.898Z',
  },
  {
    id: '86cd4f03-7af5-430b-bcde-e5397400194c',
    countryName: 'Northern Mariana Islands',
    countryCode: 'MP',
    phoneCode: '+1670',
    region: null,
    flag: 'U+1F1F2 U+1F1F5',
    active: true,
    createdAt: '2024-07-18T17:07:32.813Z',
    updatedAt: '2024-12-19T16:16:05.896Z',
  },
  {
    id: 'e67f12f3-5b27-49da-aef3-d72b63f3b021',
    countryName: 'North Korea',
    countryCode: 'KP',
    phoneCode: '+850',
    region: null,
    flag: 'U+1F1F0 U+1F1F5',
    active: true,
    createdAt: '2024-07-18T17:07:32.806Z',
    updatedAt: '2024-12-19T16:16:05.891Z',
  },
  {
    id: '548e48e1-e0a4-46e2-9802-92e1f834e4ac',
    countryName: 'North Macedonia',
    countryCode: 'MK',
    phoneCode: '+389',
    region: null,
    flag: 'U+1F1F2 U+1F1F0',
    active: true,
    createdAt: '2024-07-18T17:07:32.812Z',
    updatedAt: '2024-12-19T16:16:05.895Z',
  },
  {
    id: '1a5eb97d-578d-448a-97a2-89cc4fcbb1db',
    countryName: 'Norway',
    countryCode: 'NO',
    phoneCode: '+47',
    region: null,
    flag: 'U+1F1F3 U+1F1F4',
    active: true,
    createdAt: '2024-07-18T17:07:32.833Z',
    updatedAt: '2024-12-19T16:16:05.901Z',
  },
  {
    id: 'dde1ffa6-94ff-4979-a3e9-14e3b324d5bf',
    countryName: 'Oman',
    countryCode: 'OM',
    phoneCode: '+968',
    region: null,
    flag: 'U+1F1F4 U+1F1F2',
    active: true,
    createdAt: '2024-07-18T17:07:32.834Z',
    updatedAt: '2024-12-19T16:16:05.902Z',
  },
  {
    id: 'f4ab2e54-e4c3-4bc1-9bf9-e314bbdc3b1e',
    countryName: 'Pakistan',
    countryCode: 'PK',
    phoneCode: '+92',
    region: null,
    flag: 'U+1F1F5 U+1F1F0',
    active: true,
    createdAt: '2024-07-18T17:07:32.837Z',
    updatedAt: '2024-12-19T16:16:05.903Z',
  },
  {
    id: '5aea8de0-c359-4b11-974f-45ba69c6c294',
    countryName: 'Palau',
    countryCode: 'PW',
    phoneCode: '+680',
    region: null,
    flag: 'U+1F1F5 U+1F1FC',
    active: true,
    createdAt: '2024-07-18T17:07:32.839Z',
    updatedAt: '2024-12-19T16:16:05.904Z',
  },
  {
    id: '925dc05c-709a-4989-80d2-555cf364bcd0',
    countryName: 'Palestinian Territories',
    countryCode: 'PS',
    phoneCode: '+970',
    region: null,
    flag: 'U+1F1F5 U+1F1F8',
    active: true,
    createdAt: '2024-07-18T17:07:32.839Z',
    updatedAt: '2024-12-19T16:16:05.904Z',
  },
  {
    id: '7be4de8e-4c60-45c0-a9af-5b253bd5de3b',
    countryName: 'Panama',
    countryCode: 'PA',
    phoneCode: '+507',
    region: null,
    flag: 'U+1F1F5 U+1F1E6',
    active: true,
    createdAt: '2024-07-18T17:07:32.834Z',
    updatedAt: '2024-12-19T16:16:05.902Z',
  },
  {
    id: '81c720cf-ac96-40c4-953d-bf5c8f21779e',
    countryName: 'Papua New Guinea',
    countryCode: 'PG',
    phoneCode: '+675',
    region: null,
    flag: 'U+1F1F5 U+1F1EC',
    active: true,
    createdAt: '2024-07-18T17:07:32.837Z',
    updatedAt: '2024-12-19T16:16:05.903Z',
  },
  {
    id: '14101a9d-81f3-4d0a-8f70-a892170cb1ff',
    countryName: 'Paraguay',
    countryCode: 'PY',
    phoneCode: '+595',
    region: null,
    flag: 'U+1F1F5 U+1F1FE',
    active: true,
    createdAt: '2024-07-18T17:07:32.839Z',
    updatedAt: '2024-12-19T16:16:05.904Z',
  },
  {
    id: 'a3451b23-5cc0-49b9-b8d1-b5e5d8f14ef3',
    countryName: 'Peru',
    countryCode: 'PE',
    phoneCode: '+51',
    region: null,
    flag: 'U+1F1F5 U+1F1EA',
    active: true,
    createdAt: '2024-07-18T17:07:32.834Z',
    updatedAt: '2024-12-19T16:16:05.902Z',
  },
  {
    id: 'd77b9dca-4890-470c-8f4b-f1aaf5384761',
    countryName: 'Philippines',
    countryCode: 'PH',
    phoneCode: '+63',
    region: null,
    flag: 'U+1F1F5 U+1F1ED',
    active: true,
    createdAt: '2024-07-18T17:07:32.837Z',
    updatedAt: '2024-12-19T16:16:05.903Z',
  },
  {
    id: '5dddb238-5e65-4547-a1f3-65ec6cac45a9',
    countryName: 'Pitcairn Islands',
    countryCode: 'PN',
    phoneCode: '+872',
    region: null,
    flag: 'U+1F1F5 U+1F1F3',
    active: true,
    createdAt: '2024-07-18T17:07:32.838Z',
    updatedAt: '2024-12-19T16:16:05.903Z',
  },
  {
    id: '4f9efcdb-ea79-40b3-958c-14a24bf17cd8',
    countryName: 'Poland',
    countryCode: 'PL',
    phoneCode: '+48',
    region: null,
    flag: 'U+1F1F5 U+1F1F1',
    active: true,
    createdAt: '2024-07-18T17:07:32.838Z',
    updatedAt: '2024-12-19T16:16:05.903Z',
  },
  {
    id: 'd63fcdc8-2a6c-4aac-b055-7eaad70f0656',
    countryName: 'Portugal',
    countryCode: 'PT',
    phoneCode: '+351',
    region: null,
    flag: 'U+1F1F5 U+1F1F9',
    active: true,
    createdAt: '2024-07-18T17:07:32.839Z',
    updatedAt: '2024-12-19T16:16:05.904Z',
  },
  {
    id: 'a7ff534e-6ed5-4bb5-8872-61cb4493e155',
    countryName: 'Puerto Rico',
    countryCode: 'PR',
    phoneCode: '+1939',
    region: null,
    flag: 'U+1F1F5 U+1F1F7',
    active: true,
    createdAt: '2024-07-18T17:07:32.838Z',
    updatedAt: '2024-12-19T16:16:05.903Z',
  },
  {
    id: '4ded953d-5439-4842-9792-b5dd8ab5704a',
    countryName: 'Qatar',
    countryCode: 'QA',
    phoneCode: '+974',
    region: null,
    flag: 'U+1F1F6 U+1F1E6',
    active: true,
    createdAt: '2024-07-18T17:07:32.839Z',
    updatedAt: '2024-12-19T16:16:05.904Z',
  },
  {
    id: 'd364d479-ea22-40fc-8929-04cb3c4511fb',
    countryName: 'Reunion',
    countryCode: 'RE',
    phoneCode: '+262',
    region: null,
    flag: 'U+1F1F7 U+1F1EA',
    active: true,
    createdAt: '2024-07-18T17:07:32.839Z',
    updatedAt: '2024-12-19T16:16:05.904Z',
  },
  {
    id: '3f757c7f-ad02-4c3f-8a4f-e1d246b1deb0',
    countryName: 'Romania',
    countryCode: 'RO',
    phoneCode: '+40',
    region: null,
    flag: 'U+1F1F7 U+1F1F4',
    active: true,
    createdAt: '2024-07-18T17:07:32.840Z',
    updatedAt: '2024-12-19T16:16:05.904Z',
  },
  {
    id: '000be87f-c673-45ce-b7d5-9d341d587397',
    countryName: 'Russia',
    countryCode: 'RU',
    phoneCode: '+7',
    region: null,
    flag: 'U+1F1F7 U+1F1FA',
    active: true,
    createdAt: '2024-07-18T17:07:32.840Z',
    updatedAt: '2024-12-19T16:16:05.905Z',
  },
  {
    id: '7ce6438d-5cb7-4a13-94bb-a9a1794e8e42',
    countryName: 'Rwanda',
    countryCode: 'RW',
    phoneCode: '+250',
    region: null,
    flag: 'U+1F1F7 U+1F1FC',
    active: true,
    createdAt: '2024-07-18T17:07:32.841Z',
    updatedAt: '2024-12-19T16:16:05.905Z',
  },
  {
    id: '1b11df2f-31b8-4368-b7b6-f7d25ec56350',
    countryName: 'Samoa',
    countryCode: 'WS',
    phoneCode: '+685',
    region: null,
    flag: 'U+1F1FC U+1F1F8',
    active: true,
    createdAt: '2024-07-18T17:07:32.859Z',
    updatedAt: '2024-12-19T16:16:05.915Z',
  },
  {
    id: '5ef52e5a-00e4-4fcc-a98e-e63163a98ad9',
    countryName: 'San Marino',
    countryCode: 'SM',
    phoneCode: '+378',
    region: null,
    flag: 'U+1F1F8 U+1F1F2',
    active: true,
    createdAt: '2024-07-18T17:07:32.848Z',
    updatedAt: '2024-12-19T16:16:05.907Z',
  },
  {
    id: '67d0bc29-45f0-4bb8-b797-102704e195ec',
    countryName: 'Sao Tome & Principe',
    countryCode: 'ST',
    phoneCode: '+239',
    region: null,
    flag: 'U+1F1F8 U+1F1F9',
    active: true,
    createdAt: '2024-07-18T17:07:32.849Z',
    updatedAt: '2024-12-19T16:16:05.908Z',
  },
  {
    id: '7178579b-d9e2-4727-9753-cff7764d4ca1',
    countryName: 'Saudi Arabia',
    countryCode: 'SA',
    phoneCode: '+966',
    region: null,
    flag: 'U+1F1F8 U+1F1E6',
    active: true,
    createdAt: '2024-07-18T17:07:32.841Z',
    updatedAt: '2024-12-19T16:16:05.905Z',
  },
  {
    id: '63aaa329-0657-4fc9-993a-af90e0960ea0',
    countryName: 'Senegal',
    countryCode: 'SN',
    phoneCode: '+221',
    region: null,
    flag: 'U+1F1F8 U+1F1F3',
    active: true,
    createdAt: '2024-07-18T17:07:32.848Z',
    updatedAt: '2024-12-19T16:16:05.907Z',
  },
  {
    id: '8543e6c2-cefc-4a8d-9ea1-bca2476b96c1',
    countryName: 'Serbia',
    countryCode: 'RS',
    phoneCode: '+381',
    region: null,
    flag: 'U+1F1F7 U+1F1F8',
    active: true,
    createdAt: '2024-07-18T17:07:32.840Z',
    updatedAt: '2024-12-19T16:16:05.905Z',
  },
  {
    id: '88c89f0b-de0f-4426-a315-f2ea8527ac1b',
    countryName: 'Seychelles',
    countryCode: 'SC',
    phoneCode: '+248',
    region: null,
    flag: 'U+1F1F8 U+1F1E8',
    active: true,
    createdAt: '2024-07-18T17:07:32.841Z',
    updatedAt: '2024-12-19T16:16:05.905Z',
  },
  {
    id: '0401025a-f989-4445-a664-be80ec5f7e7d',
    countryName: 'Sierra Leone',
    countryCode: 'SL',
    phoneCode: '+232',
    region: null,
    flag: 'U+1F1F8 U+1F1F1',
    active: true,
    createdAt: '2024-07-18T17:07:32.848Z',
    updatedAt: '2024-12-19T16:16:05.907Z',
  },
  {
    id: 'ee7a0ace-dc98-4a45-acca-922155abd9b4',
    countryName: 'Singapore',
    countryCode: 'SG',
    phoneCode: '+65',
    region: null,
    flag: 'U+1F1F8 U+1F1EC',
    active: true,
    createdAt: '2024-07-18T17:07:32.847Z',
    updatedAt: '2024-12-19T16:16:05.906Z',
  },
  {
    id: '24571ec9-515e-4bf5-a751-fad329f22524',
    countryName: 'Slovakia',
    countryCode: 'SK',
    phoneCode: '+421',
    region: null,
    flag: 'U+1F1F8 U+1F1F0',
    active: true,
    createdAt: '2024-07-18T17:07:32.847Z',
    updatedAt: '2024-12-19T16:16:05.907Z',
  },
  {
    id: '3ddd5dc0-4fe2-4736-8d4a-66aa93c7d466',
    countryName: 'Slovenia',
    countryCode: 'SI',
    phoneCode: '+386',
    region: null,
    flag: 'U+1F1F8 U+1F1EE',
    active: true,
    createdAt: '2024-07-18T17:07:32.847Z',
    updatedAt: '2024-12-19T16:16:05.906Z',
  },
  {
    id: 'b23e941b-8874-4f89-8ef3-1f1477b1592e',
    countryName: 'Solomon Islands',
    countryCode: 'SB',
    phoneCode: '+677',
    region: null,
    flag: 'U+1F1F8 U+1F1E7',
    active: true,
    createdAt: '2024-07-18T17:07:32.841Z',
    updatedAt: '2024-12-19T16:16:05.905Z',
  },
  {
    id: '4814c4d6-2abb-4e4c-a3ae-fa1eca5bd8f2',
    countryName: 'Somalia',
    countryCode: 'SO',
    phoneCode: '+252',
    region: null,
    flag: 'U+1F1F8 U+1F1F4',
    active: true,
    createdAt: '2024-07-18T17:07:32.848Z',
    updatedAt: '2024-12-19T16:16:05.907Z',
  },
  {
    id: '5b948335-6684-429f-9ee9-8beefc4db7a5',
    countryName: 'South Africa',
    countryCode: 'ZA',
    phoneCode: '+27',
    region: null,
    flag: 'U+1F1FF U+1F1E6',
    active: true,
    createdAt: '2024-07-18T17:07:32.860Z',
    updatedAt: '2024-12-19T16:16:05.915Z',
  },
  {
    id: 'f19914a8-78f7-43d6-a632-bb8e41ff5625',
    countryName: 'South Georgia & South Sandwich Islands',
    countryCode: 'GS',
    phoneCode: '+500',
    region: null,
    flag: 'U+1F1EC U+1F1F8',
    active: true,
    createdAt: '2024-07-18T17:07:32.770Z',
    updatedAt: '2024-12-19T16:16:05.821Z',
  },
  {
    id: '162cd56e-d71d-4f56-a511-3ad2480e3a3d',
    countryName: 'South Korea',
    countryCode: 'KR',
    phoneCode: '+82',
    region: null,
    flag: 'U+1F1F0 U+1F1F7',
    active: true,
    createdAt: '2024-07-18T17:07:32.806Z',
    updatedAt: '2024-12-19T16:16:05.892Z',
  },
  {
    id: '9396e46b-a9bf-4396-8d09-94964be1d4fa',
    countryName: 'South Sudan',
    countryCode: 'SS',
    phoneCode: '+211',
    region: null,
    flag: 'U+1F1F8 U+1F1F8',
    active: true,
    createdAt: '2024-07-18T17:07:32.848Z',
    updatedAt: '2024-12-19T16:16:05.907Z',
  },
  {
    id: '59e65505-b1c8-4ee3-ace0-be2932371e67',
    countryName: 'Spain',
    countryCode: 'ES',
    phoneCode: '+34',
    region: null,
    flag: 'U+1F1EA U+1F1F8',
    active: true,
    createdAt: '2024-07-18T17:07:32.766Z',
    updatedAt: '2024-12-19T16:16:05.816Z',
  },
  {
    id: '1684aa3d-f178-45a5-8271-6e59fc1d95ef',
    countryName: 'Sri Lanka',
    countryCode: 'LK',
    phoneCode: '+94',
    region: null,
    flag: 'U+1F1F1 U+1F1F0',
    active: true,
    createdAt: '2024-07-18T17:07:32.807Z',
    updatedAt: '2024-12-19T16:16:05.893Z',
  },
  {
    id: '285cc980-688a-4cdc-9597-85457aae41cd',
    countryName: 'St. Barthelemy',
    countryCode: 'BL',
    phoneCode: '+590',
    region: null,
    flag: 'U+1F1E7 U+1F1F1',
    active: true,
    createdAt: '2024-07-18T17:07:32.751Z',
    updatedAt: '2024-12-19T16:16:05.809Z',
  },
  {
    id: '027059a1-7764-49f9-a762-71d243d1fa9d',
    countryName: 'St. Helena',
    countryCode: 'SH',
    phoneCode: '+290',
    region: null,
    flag: 'U+1F1F8 U+1F1ED',
    active: true,
    createdAt: '2024-07-18T17:07:32.847Z',
    updatedAt: '2024-12-19T16:16:05.906Z',
  },
  {
    id: '747d7a7f-5fd8-471f-a457-6f3a3d7924e0',
    countryName: 'St. Kitts & Nevis',
    countryCode: 'KN',
    phoneCode: '+1869',
    region: null,
    flag: 'U+1F1F0 U+1F1F3',
    active: true,
    createdAt: '2024-07-18T17:07:32.806Z',
    updatedAt: '2024-12-19T16:16:05.891Z',
  },
  {
    id: 'dff8a224-f6e1-4a70-960a-910fd803e38f',
    countryName: 'St. Lucia',
    countryCode: 'LC',
    phoneCode: '+1758',
    region: null,
    flag: 'U+1F1F1 U+1F1E8',
    active: true,
    createdAt: '2024-07-18T17:07:32.807Z',
    updatedAt: '2024-12-19T16:16:05.892Z',
  },
  {
    id: '3de61021-1dc0-4b29-8e7f-3a3c0c6d289c',
    countryName: 'St. Martin',
    countryCode: 'MF',
    phoneCode: '+590',
    region: null,
    flag: 'U+1F1F2 U+1F1EB',
    active: true,
    createdAt: '2024-07-18T17:07:32.812Z',
    updatedAt: '2024-12-19T16:16:05.895Z',
  },
  {
    id: '99ce7400-0255-48a5-963b-5e6630307fd8',
    countryName: 'St. Pierre & Miquelon',
    countryCode: 'PM',
    phoneCode: '+508',
    region: null,
    flag: 'U+1F1F5 U+1F1F2',
    active: true,
    createdAt: '2024-07-18T17:07:32.838Z',
    updatedAt: '2024-12-19T16:16:05.903Z',
  },
  {
    id: '376e741f-3c7a-4ed9-b2e8-f78d541f21e0',
    countryName: 'St. Vincent & Grenadines',
    countryCode: 'VC',
    phoneCode: '+1784',
    region: null,
    flag: 'U+1F1FB U+1F1E8',
    active: true,
    createdAt: '2024-07-18T17:07:32.857Z',
    updatedAt: '2024-12-19T16:16:05.914Z',
  },
  {
    id: '803e21b1-a489-4c3c-88c0-09812392a8ec',
    countryName: 'Sudan',
    countryCode: 'SD',
    phoneCode: '+249',
    region: null,
    flag: 'U+1F1F8 U+1F1E9',
    active: true,
    createdAt: '2024-07-18T17:07:32.841Z',
    updatedAt: '2024-12-19T16:16:05.906Z',
  },
  {
    id: '8c2fb2a6-e3bb-4408-a6e4-e9ad1b612a25',
    countryName: 'Suriname',
    countryCode: 'SR',
    phoneCode: '+597',
    region: null,
    flag: 'U+1F1F8 U+1F1F7',
    active: true,
    createdAt: '2024-07-18T17:07:32.848Z',
    updatedAt: '2024-12-19T16:16:05.907Z',
  },
  {
    id: 'e4a6e77c-f678-4b54-a2b8-75cdda26ca0c',
    countryName: 'Svalbard & Jan Mayen',
    countryCode: 'SJ',
    phoneCode: '+47',
    region: null,
    flag: 'U+1F1F8 U+1F1EF',
    active: true,
    createdAt: '2024-07-18T17:07:32.847Z',
    updatedAt: '2024-12-19T16:16:05.906Z',
  },
  {
    id: '2c669a58-b955-43dc-8c20-228a01fbd954',
    countryName: 'Sweden',
    countryCode: 'SE',
    phoneCode: '+46',
    region: null,
    flag: 'U+1F1F8 U+1F1EA',
    active: true,
    createdAt: '2024-07-18T17:07:32.842Z',
    updatedAt: '2024-12-19T16:16:05.906Z',
  },
  {
    id: '8545c0df-a8d0-4e90-988a-dd6cc8beac67',
    countryName: 'Switzerland',
    countryCode: 'CH',
    phoneCode: '+41',
    region: null,
    flag: 'U+1F1E8 U+1F1ED',
    active: true,
    createdAt: '2024-07-18T17:07:32.757Z',
    updatedAt: '2024-12-19T16:16:05.811Z',
  },
  {
    id: '2ea2da01-5b9d-4cd5-b8e8-31315ad2874b',
    countryName: 'Syria',
    countryCode: 'SY',
    phoneCode: '+963',
    region: null,
    flag: 'U+1F1F8 U+1F1FE',
    active: true,
    createdAt: '2024-07-18T17:07:32.849Z',
    updatedAt: '2024-12-19T16:16:05.908Z',
  },
  {
    id: '202b2850-cf0a-433f-a712-f9af7506b0b5',
    countryName: 'Taiwan',
    countryCode: 'TW',
    phoneCode: '+886',
    region: null,
    flag: 'U+1F1F9 U+1F1FC',
    active: true,
    createdAt: '2024-07-18T17:07:32.855Z',
    updatedAt: '2024-12-19T16:16:05.911Z',
  },
  {
    id: 'e186de09-8bbd-4753-b060-7465036f783b',
    countryName: 'Tajikistan',
    countryCode: 'TJ',
    phoneCode: '+992',
    region: null,
    flag: 'U+1F1F9 U+1F1EF',
    active: true,
    createdAt: '2024-07-18T17:07:32.850Z',
    updatedAt: '2024-12-19T16:16:05.909Z',
  },
  {
    id: 'c9a045bc-85e5-4cd5-b56f-11ae7c7e8777',
    countryName: 'Tanzania',
    countryCode: 'TZ',
    phoneCode: '+255',
    region: null,
    flag: 'U+1F1F9 U+1F1FF',
    active: true,
    createdAt: '2024-07-18T17:07:32.855Z',
    updatedAt: '2024-12-19T16:16:05.913Z',
  },
  {
    id: '478aa4d7-7cb2-458a-8cf8-69e29be57c0c',
    countryName: 'Thailand',
    countryCode: 'TH',
    phoneCode: '+66',
    region: null,
    flag: 'U+1F1F9 U+1F1ED',
    active: true,
    createdAt: '2024-07-18T17:07:32.850Z',
    updatedAt: '2024-12-19T16:16:05.909Z',
  },
  {
    id: '24d50c46-92bc-46ba-ad31-f6b0c1201488',
    countryName: 'Timor-Leste',
    countryCode: 'TL',
    phoneCode: '+670',
    region: null,
    flag: 'U+1F1F9 U+1F1F1',
    active: true,
    createdAt: '2024-07-18T17:07:32.851Z',
    updatedAt: '2024-12-19T16:16:05.909Z',
  },
  {
    id: '99483d68-9553-4b14-9745-431e7eed26f8',
    countryName: 'Togo',
    countryCode: 'TG',
    phoneCode: '+228',
    region: null,
    flag: 'U+1F1F9 U+1F1EC',
    active: true,
    createdAt: '2024-07-18T17:07:32.849Z',
    updatedAt: '2024-12-19T16:16:05.909Z',
  },
  {
    id: '424983c5-e10b-45cf-b2dd-23269af5ada0',
    countryName: 'Tokelau',
    countryCode: 'TK',
    phoneCode: '+690',
    region: null,
    flag: 'U+1F1F9 U+1F1F0',
    active: true,
    createdAt: '2024-07-18T17:07:32.851Z',
    updatedAt: '2024-12-19T16:16:05.909Z',
  },
  {
    id: '483e257d-2e0a-46eb-891c-58b6e3c3ddba',
    countryName: 'Tonga',
    countryCode: 'TO',
    phoneCode: '+676',
    region: null,
    flag: 'U+1F1F9 U+1F1F4',
    active: true,
    createdAt: '2024-07-18T17:07:32.851Z',
    updatedAt: '2024-12-19T16:16:05.910Z',
  },
  {
    id: 'ed0a897d-218c-4130-b2cd-4b86bdfba863',
    countryName: 'Trinidad & Tobago',
    countryCode: 'TT',
    phoneCode: '+1868',
    region: null,
    flag: 'U+1F1F9 U+1F1F9',
    active: true,
    createdAt: '2024-07-18T17:07:32.852Z',
    updatedAt: '2024-12-19T16:16:05.910Z',
  },
  {
    id: '9c36815e-c287-4f8c-b8df-29647a427097',
    countryName: 'Tunisia',
    countryCode: 'TN',
    phoneCode: '+216',
    region: null,
    flag: 'U+1F1F9 U+1F1F3',
    active: true,
    createdAt: '2024-07-18T17:07:32.851Z',
    updatedAt: '2024-12-19T16:16:05.910Z',
  },
  {
    id: 'e12c01ee-8fd7-41eb-9838-889d4393d3d6',
    countryName: 'Turkey',
    countryCode: 'TR',
    phoneCode: '+90',
    region: null,
    flag: 'U+1F1F9 U+1F1F7',
    active: true,
    createdAt: '2024-07-18T17:07:32.852Z',
    updatedAt: '2024-12-19T16:16:05.910Z',
  },
  {
    id: '9ec2fc0a-591f-4f5a-911e-b4f5f91d764e',
    countryName: 'Turkmenistan',
    countryCode: 'TM',
    phoneCode: '+993',
    region: null,
    flag: 'U+1F1F9 U+1F1F2',
    active: true,
    createdAt: '2024-07-18T17:07:32.851Z',
    updatedAt: '2024-12-19T16:16:05.910Z',
  },
  {
    id: '65093f35-0bca-4ade-9e57-64b7fc2dd771',
    countryName: 'Turks & Caicos Islands',
    countryCode: 'TC',
    phoneCode: '+1649',
    region: null,
    flag: 'U+1F1F9 U+1F1E8',
    active: true,
    createdAt: '2024-07-18T17:07:32.849Z',
    updatedAt: '2024-12-19T16:16:05.908Z',
  },
  {
    id: '7cf8ad30-8381-4626-9bad-eed0cb9d11b0',
    countryName: 'Tuvalu',
    countryCode: 'TV',
    phoneCode: '+688',
    region: null,
    flag: 'U+1F1F9 U+1F1FB',
    active: true,
    createdAt: '2024-07-18T17:07:32.852Z',
    updatedAt: '2024-12-19T16:16:05.910Z',
  },
  {
    id: '4fba17da-4e10-4cc4-8c1c-8577399f70fc',
    countryName: 'Uganda',
    countryCode: 'UG',
    phoneCode: '+256',
    region: null,
    flag: 'U+1F1FA U+1F1EC',
    active: true,
    createdAt: '2024-07-18T17:07:32.856Z',
    updatedAt: '2024-12-19T16:16:05.913Z',
  },
  {
    id: 'f0aa800a-4a36-485e-be84-662fe2dee7b7',
    countryName: 'Ukraine',
    countryCode: 'UA',
    phoneCode: '+380',
    region: null,
    flag: 'U+1F1FA U+1F1E6',
    active: true,
    createdAt: '2024-07-18T17:07:32.856Z',
    updatedAt: '2024-12-19T16:16:05.913Z',
  },
  {
    id: '2561a6e3-9a00-4a84-aad0-e3f787bc285b',
    countryName: 'United Arab Emirates',
    countryCode: 'AE',
    phoneCode: '+971',
    region: null,
    flag: 'U+1F1E6 U+1F1EA',
    active: true,
    createdAt: '2024-07-18T17:07:32.614Z',
    updatedAt: '2024-12-19T16:16:05.699Z',
  },
  {
    id: '16562407-a6ee-4661-b3d3-d00a24a8997a',
    countryName: 'United Kingdom',
    countryCode: 'GB',
    phoneCode: '+44',
    region: null,
    flag: 'U+1F1EC U+1F1E7',
    active: true,
    createdAt: '2024-07-18T17:07:32.768Z',
    updatedAt: '2024-12-19T16:16:05.818Z',
  },
  {
    id: '21c2989b-d71c-46a7-9b31-e9fce1a9f2a5',
    countryName: 'United States',
    countryCode: 'US',
    phoneCode: '+1',
    region: null,
    flag: 'U+1F1FA U+1F1F8',
    active: true,
    createdAt: '2024-07-18T17:07:32.856Z',
    updatedAt: '2024-12-19T16:16:05.913Z',
  },
  {
    id: '269828f8-2395-4469-81b8-310fca2f09d6',
    countryName: 'Uruguay',
    countryCode: 'UY',
    phoneCode: '+598',
    region: null,
    flag: 'U+1F1FA U+1F1FE',
    active: true,
    createdAt: '2024-07-18T17:07:32.856Z',
    updatedAt: '2024-12-19T16:16:05.913Z',
  },
  {
    id: '50aaf259-f418-4d76-9538-0fe1340bfba2',
    countryName: 'U.S. Virgin Islands',
    countryCode: 'VI',
    phoneCode: '+1340',
    region: null,
    flag: 'U+1F1FB U+1F1EE',
    active: true,
    createdAt: '2024-07-18T17:07:32.858Z',
    updatedAt: '2024-12-19T16:16:05.915Z',
  },
  {
    id: '4fdb8083-91ce-4997-9828-c5dc61b8c207',
    countryName: 'Uzbekistan',
    countryCode: 'UZ',
    phoneCode: '+998',
    region: null,
    flag: 'U+1F1FA U+1F1FF',
    active: true,
    createdAt: '2024-07-18T17:07:32.857Z',
    updatedAt: '2024-12-19T16:16:05.914Z',
  },
  {
    id: '3f37a67a-1f6c-4b37-af16-b62a3eb7f504',
    countryName: 'Vanuatu',
    countryCode: 'VU',
    phoneCode: '+678',
    region: null,
    flag: 'U+1F1FB U+1F1FA',
    active: true,
    createdAt: '2024-07-18T17:07:32.858Z',
    updatedAt: '2024-12-19T16:16:05.915Z',
  },
  {
    id: 'c8248bc0-5647-4702-8cc0-96d8a7d71ce7',
    countryName: 'Vatican City',
    countryCode: 'VA',
    phoneCode: '+379',
    region: null,
    flag: 'U+1F1FB U+1F1E6',
    active: true,
    createdAt: '2024-07-18T17:07:32.857Z',
    updatedAt: '2024-12-19T16:16:05.914Z',
  },
  {
    id: 'd5de0025-6852-4e74-92df-92971ee447b1',
    countryName: 'Venezuela',
    countryCode: 'VE',
    phoneCode: '+58',
    region: null,
    flag: 'U+1F1FB U+1F1EA',
    active: true,
    createdAt: '2024-07-18T17:07:32.857Z',
    updatedAt: '2024-12-19T16:16:05.914Z',
  },
  {
    id: 'aa9edf8e-f7bd-4f99-a699-d2ad9a284e08',
    countryName: 'Vietnam',
    countryCode: 'VN',
    phoneCode: '+84',
    region: null,
    flag: 'U+1F1FB U+1F1F3',
    active: true,
    createdAt: '2024-07-18T17:07:32.858Z',
    updatedAt: '2024-12-19T16:16:05.915Z',
  },
  {
    id: '440a76db-5afd-4aa9-8552-95568c3cade5',
    countryName: 'Wallis & Futuna',
    countryCode: 'WF',
    phoneCode: '+681',
    region: null,
    flag: 'U+1F1FC U+1F1EB',
    active: true,
    createdAt: '2024-07-18T17:07:32.859Z',
    updatedAt: '2024-12-19T16:16:05.915Z',
  },
  {
    id: '3d3f263e-66bb-4f70-8ff5-4f1776fc9492',
    countryName: 'Yemen',
    countryCode: 'YE',
    phoneCode: '+967',
    region: null,
    flag: 'U+1F1FE U+1F1EA',
    active: true,
    createdAt: '2024-07-18T17:07:32.859Z',
    updatedAt: '2024-12-19T16:16:05.915Z',
  },
  {
    id: 'fb5b8342-126d-4563-9f2a-57aca97f1714',
    countryName: 'Zambia',
    countryCode: 'ZM',
    phoneCode: '+260',
    region: null,
    flag: 'U+1F1FF U+1F1F2',
    active: true,
    createdAt: '2024-07-18T17:07:32.860Z',
    updatedAt: '2024-12-19T16:16:05.916Z',
  },
  {
    id: 'a2a94fac-1538-4d50-b13d-4e251c2db011',
    countryName: 'Zimbabwe',
    countryCode: 'ZW',
    phoneCode: '+263',
    region: null,
    flag: 'U+1F1FF U+1F1FC',
    active: true,
    createdAt: '2024-07-18T17:07:32.860Z',
    updatedAt: '2024-12-19T16:16:05.916Z',
  },
]
